module.exports = __webpack_public_path__ + "img/registration-min.983ebcf4.gif";